import i18next from 'i18next'

export async function getBlogTeasers(blogIds: number[]): Promise<any> {
  const headers = new Headers()
  headers.append('content-type', 'application/json')
  const res = await fetch(
    `/api/v1/blogs/teasers?blogIds=${blogIds.join()}&language=${
      i18next.language
    }`,
    { method: 'get', headers: headers }
  )
  if (!res.ok) throw Error(res.statusText)
  return await res.json()
}
